export default "__VITE_ASSET__CIg7bSLE__"